const _import = name => {
  return resolve => require([`../../views/${name}`], resolve)
}
const DepositChild = {
  path: '/SaveMonery',
  component: _import('SaveMonery'),
  children: [{
      path: '',
      meta: {
        navShow: false,
        titleHide: true,
        requireAuth: true,
        title: '存款'
      },
      name: 'saveMonery',
      component: _import('SaveMonery/Base'),
    },
    {
      path: 'BankTransfer',
      meta: {
        navShow: false,
        titleHide: true,
        title: '银行汇款'
      },
      name: 'BankTransfer',
      component: _import('SaveMonery/BankTransfer'),
    },
    {
      path: 'UsdtTransfer',
      meta: {
        navShow: false,
        titleHide: true,
        title: 'USDT'
      },
      name: 'USDTTransfer',
      component: _import('SaveMonery/UsdtTransfer'),
    },
    {
      path: 'otherTransfer',
      meta: {
        navShow: false,
        titleHide: true,
        title: 'otherTransfer'
      },
      name: 'otherTransfer',
      component: _import('SaveMonery/otherTransfer'),
    },
    {
      path: 'recharge',
      meta: {
        navShow: false,
        titleHide: true,
        title: 'Recharge'
      },
      name: 'Recharge',
      component: _import('SaveMonery/Recharge'),
    }
  ]
}

export default DepositChild



// WEBPACK FOOTER //
// ./src/pages/build902/router/module/Deposit.js